import { render, staticRenderFns } from "./AutoSizeTextarea.vue?vue&type=template&id=1fe831ee&scoped=true&"
import script from "./AutoSizeTextarea.vue?vue&type=script&lang=ts&"
export * from "./AutoSizeTextarea.vue?vue&type=script&lang=ts&"
import style0 from "./AutoSizeTextarea.vue?vue&type=style&index=0&id=1fe831ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe831ee",
  null
  
)

export default component.exports